/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Tabs, Tab } from '@components/molecules'

export interface TabType {
	index: number
	id: string
	label: string
	panel?: React.ReactNode
}

interface PropsType {
	tabList: TabType[]
	tabIndex: number
	onIndexChange: (index: number) => void
}

/** 박스 헤더 자리의 탭 — 외형은 BackofficeTheme(MuiTabs·MuiTab)이 정한다 */
export const BoxTab = (props: PropsType) => {
	const [value, setValue] = React.useState(props.tabIndex)

	const onIndexChange = (e: React.SyntheticEvent, newIndex: number) => {
		setValue(newIndex)
		props.onIndexChange(newIndex)
	}

	return (
		<Tabs css={style} value={value} onChange={onIndexChange} aria-label="목록 탭">
			{props.tabList.map(aTab => (
				<Tab key={aTab.id} label={aTab.label} className="tabItem" />
			))}
		</Tabs>
	)
}

const style = css({
	minHeight: 34,
	height: 34,

	'.tabItem': {
		minHeight: 34,
		height: 34,
		minWidth: 0,
		padding: '0 4px',
		marginRight: 20,
		fontSize: 15,
		fontWeight: 400,
	},
})
